import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import ReportPage, { col, PrintButton, usePrintDocument } from "../../../auxiliary/report/ReportPage";
import PrintDocument from "../../print/printDocument";

const SPReportList = () => {
	const [t] = useTranslation("global");
	const { querySPPurchaseDealerByDate, querySPPurchaseVProfileDealerById } = useDealer();
	const branchcode = useSelector((state) => state?.another?._currentUser?.branchcode);
	const { busy, print } = usePrintDocument();

	const printDoc = (purchaseProductId) =>
		print(async () => {
			const response = await querySPPurchaseVProfileDealerById(purchaseProductId);
			if (!response) return null;
			const doc = {
				spbundle: {
					bundleType: response?.inT_MSISDNStatusType,
				},
				spMsisdn: [{ msisdn: response?.inT_MSISDN }],
				spKit: response?.stR_ICCID?.slice(9, 19),
				profile: {
					fname: response?.stR_FName,
					lname: response?.stR_LName,
					fathername: response?.stR_FatherName,
					certno: response?.stR_CertNo,
					birthdate: response?.dtE_BirthDate,
					txtCountry: "",
					gender: response?.inT_Gender,
					email: response?.stR_Email,
					postalcode: response?.address?.stR_PostalCode,
					txtProvince: response?.province?.stR_ProvinceName,
					txtCity: response?.city?.stR_CityName,
					mainstreet: response?.address?.stR_MainStreet,
					buildingno: response?.address?.stR_BuildingNo,
					floor: response?.address?.stR_Floor,
				},
				branchcode,
			};
			return <PrintDocument print={doc} />;
		});

	const columns = [
		col("نام کاربری", "username"),
		col("شماره", "msisdn"),
		col("شماره کیت", "kit"),
		col("عنوان بسته", "packageName", { wrap: true }),
		col("قیمت (تومان)", "price"),
		col("سودفروش (تومان)", "commission"),
		col("تاریخ خرید", "purchaseDate"),
		col("وضعیت", "status"),
		col("چاپ سند", "printdoc", {
			excel: false,
			render: (_, row) => (
				<PrintButton onClick={() => printDoc(row._raw.purchaseproductid)} />
			),
		}),
	];

	return (
		<ReportPage
			title={t("simcardpurchase.report.title")}
			prefix="sp"
			query={querySPPurchaseDealerByDate}
			columns={columns}
			toRow={(item) => ({
				username: item.username,
				msisdn: item.msisdn,
				kit: item.iccid?.slice(9, 19),
				packageName: item.packagename,
				price: complexDigitToman(item.purchaseamount),
				commission: complexDigitToman(item.packageCommssion),
				purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
				status: item.purchasestate,
			})}
			excel={{ sheet: "گزارش خرید سیم‌کارت", file: "sim-sales-report.xlsx" }}
			busy={busy}
		/>
	);
};

export default SPReportList;
